import { workbenchRoute } from '@ps/router/config'

export default {
  path: '/workbench',
  name: workbenchRoute.name,
  // route level code-splitting
  // this generates a separate chunk (workbench.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "workbench" */ '@ps/views/workbench')
}
